/**
 * The `records.callCategory.*` key under which a record's category is shown.
 *
 * `missed` is one category in the data for two opposite events — somebody
 * called us and nobody picked up, or we called and the client did not — and
 * the direction says which (#2562): «Пропущенный» (inbound), «Клиент не
 * ответил» (outbound), «Пропущенный, направление неизвестно» (anything else,
 * the flow's own third group). Only a call has a direction: a chat labelled
 * `missed` keeps the plain label.
 *
 * `channel` is the record's `channel` (list) or `type` (detail) — both say
 * `call` for a call.
 */
export function callCategoryLabelKey(
  category: string,
  channel: string | undefined,
  direction: string | null | undefined
): string {
  if (category !== 'missed' || channel !== 'call') return `callCategory.${category}`;
  if (direction === 'inbound') return 'callCategory.missed';
  if (direction === 'outbound') return 'callCategory.missedOutbound';
  return 'callCategory.missedUnknownDirection';
}
